import MessageSticker from './MessageSticker';

export default MessageSticker;
